export default "__VITE_ASSET__nlujnt5p__"